<template>
	<!-- This is just the primary button style.
         However, we want to avoid having too many primary buttons per view.
         Therefore, this style should not be the default!
         We need meaningful default nudges for developers.
    -->
	<button
		:type="nativeType"
		:disabled="disabled"
		:class="[
			type == 'blank' ? '' : '',
			type == 'primary'
				? 'truncate bg-orange-500 text-white px-4 py-1.5 font-medium rounded-lg focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400 shadow hover:shadow-md hover:bg-orange-600 focus:outline-none font-medium' +
				  (disabled ? ' opacity-50' : '')
				: '',
			//type == 'primary' ? 'truncate bg-orange-500 text-white px-4 py-1.5 font-medium rounded-lg focus:ring-2 focus:ring-orange-200' : '',
			type == 'success'
				? 'truncate bg-green-500 text-white px-4 py-1.5 font-medium rounded-lg focus:ring-2 focus:ring-green-200'
				: '',
			type == 'secondary'
				? 'bg-gray-150 rounded-lg py-1.5 px-4 font-medium text-gray-500 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400'
				: '',
			type == 'primary-reverted'
				? 'truncate bg-white-500 text-orange px-4 py-1.5 font-medium rounded-lg border-orange ring-2 ring-orange-400 focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400 shadow hover:shadow-md hover:bg-orange-600 hover:text-white focus:outline-none font-medium'
				: '',
			type == 'primary-disabled'
				? 'bg-gray-300 rounded-lg py-1.5 px-4 font-medium text-white focus:outline-none'
				: '',
		]"
		v-on:click="$emit('click')"
	>
		<slot>{{ __(label) }}</slot>
	</button>
</template>

<script>
export default {
	props: {
		label: {
			type: String,
			default: "Click me!",
		},
		type: {
			type: String,
			default: "primary",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		nativeType: {
			type: String,
			default: "button",
		},
	},
};
</script>
